import { BROWSER_WARNING } from 'framework/ui/BrowserWarningNotification';

// eslint-disable-next-line import/prefer-default-export
export const NOTIFICATIONS_TYPES = {
  INTERRUPTION: 'INTERRUPTION',
  LEAD_NEW: 'LEAD_NEW',
  LEAD_STALE: 'LEAD_STALE',
  POLICY: 'POLICY',
  COMMERCIAL_STATE: 'COMMERCIAL_STATE',
  BROWSER_WARNING: BROWSER_WARNING,
} as const;
